"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const functions_1 = require("../_internals/functions");
const _tools_1 = require("../_tools");
const Union_1 = require("../Union");
const union_1 = __importDefault(require("../Union/union"));
const symbols_1 = require("../_internals/symbols");
const Async_1 = __importDefault(require("../Async"));
const MaybeType = () => (cases) => {
    cases.Just.prototype.ifNone = function () {
        return this;
    };
    cases.Just.prototype.ifJust = function (fn) {
        return fn(this.get());
    };
    cases.None.prototype.ifNone = function (fn) {
        return fn();
    };
    cases.None.prototype.ifJust = function () {
        return this;
    };
    cases.Just.prototype.toAsync = function () {
        return Async_1.default.Success(this.get());
    };
    cases.None.prototype.toAsync = function () {
        return Async_1.default.Fail(undefined);
    };
};
const MaybeDefs = {
    trivials: ["Just"],
    identities: ["None"],
    empties: ["None"],
    pure: "Just",
    zero: "None",
    resolve: ["Just"],
    reject: ["None"],
    overrides: {
        fmap: undefined,
        tap: undefined,
        equals: undefined,
        chain: undefined,
        apply: undefined,
        concat: undefined,
        toPromise: undefined,
        traverse: undefined,
        show: {
            None() {
                return `[Maybe => None]`;
            },
        },
        empty: {
            Just() {
                return Maybe.fromNullish((0, functions_1.empty)(this.get()));
            },
        },
        filter: {
            Just(fn) {
                return Maybe.fromCondition(fn, this.get());
            },
        },
        fold: {
            Just(onNone, onJust) { return onJust(this.get()); },
            None(onNone, onJust) { return onNone(); }
        }
    },
};
function defaultConstructor(x) {
    return x ? this.Just(x) : this.None();
}
const Maybe = (0, union_1.default)("Maybe", {
    Just: (x) => x,
    None: () => { },
}, [
    (0, Union_1.Functor)(MaybeDefs),
    (0, Union_1.Applicative)(MaybeDefs),
    (0, Union_1.Monad)(MaybeDefs),
    (0, Union_1.Tap)(MaybeDefs),
    (0, Union_1.Eq)(MaybeDefs),
    (0, Union_1.Semigroup)(MaybeDefs),
    (0, Union_1.Monoid)(MaybeDefs),
    (0, Union_1.Filterable)(MaybeDefs),
    (0, Union_1.Thenable)(MaybeDefs),
    (0, Union_1.Show)(MaybeDefs),
    (0, Union_1.Foldable)(MaybeDefs),
    (0, Union_1.Traversable)(MaybeDefs),
    MaybeType(),
]).constructors({
    of: defaultConstructor,
    from: defaultConstructor,
    fromFalsy: defaultConstructor,
    fromArray(arr) {
        return arr.length === 0 ? this.None() : this.Just(arr);
    },
    fromNullish(x) {
        return (0, functions_1.isNil)(x) ? this.None() : this.Just(x);
    },
    fromEmpty(x) {
        return (0, functions_1.isEmpty)(x) ? this.None() : this.Just(x);
    },
    fromPredicate(pred, val) {
        return pred(val) ? this.Just(val) : this.None();
    },
    fromCondition(pred, val) {
        return pred(val) ? this.Just(val) : this.None();
    },
    isEmpty(x) {
        const t = (0, symbols_1.getTypeName)(x);
        if (t !== "Maybe") {
            return false;
        }
        return x.isNone() || (0, functions_1.isEmpty)(x.get());
    },
    match: _tools_1.match,
    equals: functions_1.equals,
});
exports.default = Maybe;
